export const PreviewMessage = () => (
  <p>Start editing to see the live preview!</p>
);
